// extracted by mini-css-extract-plugin
export var underlinedLink = "_ou-0";